export default "__VITE_ASSET___EViL3vN__"